// @flow
import React from 'react';
import { isEmpty } from 'lodash';

import { Card, type CardProps } from 'Components/frameworks/card/Card.jsx';
import { Product } from 'Components/widgets/product/Product.jsx';
import type { ProductProps } from 'Components/widgets/product/Product.utils';

export type ProductTeaserProps = {
  card: CardProps,
  product: ProductProps,
};

export function ProductTeaser({ card, product }: ProductTeaserProps) {
  if (isEmpty(card)) return null;

  return (
    <div className="flex flex-wrap -mx-2">
      <div
        className={
          isEmpty(product) ? 'px-2 w-full' : 'px-2 pb-2 sm:pb-0 sm:mb-0 w-full sm:w-2/3 lg:3/4'
        }
      >
        <Card theme="destination" {...card} />
      </div>
      {!isEmpty(product) && (
        <div className="px-2 pt-2 sm:pt-0 w-full sm:w-1/3 lg:1/4">
          <Product {...product} />
        </div>
      )}
    </div>
  );
}
